// External Imports
import { useContext, useEffect, useState } from "react";
import Modal from "../UI/Modal";
import { MdClose } from "react-icons/md";
import DataContext from "../../context/data-context";

// Internal Imports

/** ========================================================================
 * * Notification Component
 * This component renders a modal displaying a notification.
 * ========================================================================== */

export default function Notification() {
  const [open, setOpen] = useState(false);
  const { partner } = useContext(DataContext);

  useEffect(() => {
    // Get NotificationViewed from local storage
    const viewed = localStorage.getItem("notificationViewed");
    if (!viewed) {
      // wait for 2 second to show the modal
      setTimeout(() => {
        setOpen(true);
          localStorage.setItem("notificationViewed", "true");
      }, 2000);
    }
  }, []);

  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="modal p-6 lg:max-w-[40vw] text-stone-200">
        <div className="flex items-center justify-end">
          <MdClose onClick={() => setOpen(false)} className="icon" />
        </div>
        <div className="grid gap-6">
          <div className="grid gap-2 text-center">
            <p className="text-sm font-semibold text-stone-200">WELCOME TO</p>
            <div className="flex items-center justify-center space-x-2 text-center">
              <p className="-mb-1 text-3xl font-bold text-yellow-600 font-Play">
                POSH
              </p>
              <p className="text-2xl text-stone-400">|</p>
              <p className="text-2xl font-light text-stone-400">
                Partner Dashboard
              </p>
            </div>
            <p className="text-xs text-stone-400">version 2.0.1</p>
          </div>

          <div className="grid gap-1 mx-2 text-sm text-left text-stone-400 lg:mx-12">
            <p className="text-base font-semibold text-stone-200">
              Release Notes:
            </p>
            <hr className="mb-2 hr " />
            <p>
              <span className="font-semibold text-stone-200">
                1. UI Updates:
              </span>{" "}
              The interface has been revamped to improve user experience and be
              coherent with POSH's design language.
            </p>
            <p>
              <span className="font-semibold text-stone-200">
                2. Account Types:
              </span>{" "}
              Business and Individual accounts types are now separated. Contact
              support to learn more.
            </p>
            <p>
              <span className="font-semibold text-stone-200">3. Payments:</span>{" "}
              All payment history including installments, credits,
              reimbursements etc. are now displayed in the Payments tab.
            </p>
            <p>
              <span className="font-semibold text-stone-200">
                4. Asset Values:
              </span>{" "}
              You can now view real-time market values of your vehicles to
              analyze your portfolio's proceedings.
            </p>
            <p>
              <span className="font-semibold text-stone-200">
                5. Bug Fixes & Improvements:
              </span>{" "}
              Automatic VIN decoding implemented. Improved querying. Date input
              issues resolved.
            </p>
          </div>

          <div className="grid gap-1 mx-2 text-sm text-left lg:mx-12">
            <p className="text-base font-semibold text-red-500">DISCLAIMER:</p>
            <hr className="mb-2 hr " />
            <p>
              Values displayed might be inaccurate as we are still in the
              process of digitizing and updating all records. Please report any
              issues you encounter. We will notify you once the process is
              complete.
            </p>
          </div>

          <div className="mt-4 text-center">
            <p className="text-lg font-semibold">
              Thank you, {partner?.name?.split(" ")[0]}! ☺️
            </p>
            <p className="text-sm text-stone-400">
              We value your contribution to{" "}
              <span className="font-semibold">POSH</span> <br /> and strive to
              continuously improve our partnership!
            </p>
          </div>
          <div
            onClick={() => setOpen(false)}
            className="mx-auto mb-6 text-sm lg:w-32 btn-primary"
          >
            Close
          </div>
        </div>
      </div>
    </Modal>
  );
}
